# Changelog

## Development

## v1.1.6 - 2026-11-02

- Zapisano makiety i szczegółową specyfikację protokołu przekazania dyżuru: wariant sekcyjny, walidacja, delegacja kontroli leków, remanent, historia oraz podglądy desktop/mobile. Moduł protokołów pozostaje na etapie wdrożenia.

- Przyspieszono otwieranie magazynu: usunięto podwójne ładowanie, współdzielone są równoległe żądania tego samego użytkownika i zakresu. Dashboard magazynu nie pobiera zadań, szablonów, powiadomień ani profili; zwraca wyłącznie potrzebne dane i partie z dodatnią ilością. Edycja opiekunów pobiera osobny, ograniczony zakres.

## v1.1.5 - 2026-11-02

- Zabezpieczono aktualizacje web przed przestarzałym cache CDN: worker i pliki aktualizacji są pobierane pod adresami z identyfikatorem buildu, a metadane wydania z parametrem odświeżenia. Zachowano kontrolę integralności i kompletności cache.

## v1.1.4 - 2026-11-02

- Usunięto ostrzeżenia ESLinta w ekranach katalogu, raportów, magazynów, strony głównej i ewidencji; odświeżanie ewidencji ma stabilne zależności, a doładowanie kolejnej strony osobną obsługę. Zadania GitHub Actions przypięto do Ubuntu 24.04, aby uniezależnić je od migracji etykiety `ubuntu-latest`.

## v1.1.3 - 2026-11-02

- Ujednolicono nagłówki pobrań w ewidencji do „POBIERZ”, także dla sprzętu wielorazowego i pobrań mieszanych. Pozycje wielorazowe nadal pokazują „Użyto” bez pomniejszania stanów.

- W „Informacjach o Aplikacji” obok wersji wyświetlany jest krótki hash commita przekazywany podczas budowania aplikacji.

- Dodano typy przedmiotów: jednorazowy (domyślny także dla starszych wpisów) i wielorazowy. Pobór wielorazowego pokazuje przycisk „Użyto” i zapisuje zdarzenie bez pomniejszania stanów ani partii; dodawanie, transfer i remanent zachowują ilości. Raporty rozdzielają zużycie od liczby użyć, a dawna historia zachowuje pierwotne znaczenie.

## v1.1.2 - 2026-11-01

- Dodano mikro-kropki terminów w podglądzie magazynu: szarą dla nieokreślonych dat, żółtą do 3 miesięcy i czerwoną do miesiąca lub po terminie. Sygnały przy ikonie produktu są agregowane do wszystkich kategorii nadrzędnych, także zwiniętych; pomijane są zera i wyłączone rodzaje terminów.

## v1.1.1 - 2026-11-01

- Naprawiono błąd SPLIT_STORE_REQUIRED przy włączaniu terminów w magazynach ponad 100 pozycji. Migracja zapisuje porcje z możliwością wznowienia, blokuje równoległe zmiany stanów i zachowuje ilości. Pobór i przesunięcia odczytują tylko wybrany produkt zamiast ograniczać rozmiar całego magazynu.

- Ujednolicono pozycję „Zadania” w menu bocznym: korzysta z tych samych odstępów, typografii i rozmiaru ikony co pozostałe pozycje na komputerze i urządzeniach mobilnych.

## v1.1.0 - 2026-11-01

- Dodano przycisk „Changelog / historia zmian” w ekranie kontaktu oraz historię z rozwijanymi wersjami głównymi i minor, datami i poprawkami patch. Treść pochodzi bezpośrednio z tego pliku i jest dostępna offline. Odtworzono wydania 1.0.1–1.0.75 na podstawie tagów i historii commitów.
- Przygotowano wersję 1.1.0. Automatyzacja wydania testuje właściwy commit, zachowuje jawnie podniesioną wersję, synchronizuje metadane npm/Expo i Androida, finalizuje changelog i przekazuje dokładny commit wydania do wdrożenia web oraz budowy Androida.
- Uzupełniono historię po 1.0.75: dodano potwierdzenie po udanym zapisie użycia oraz roczne numerowanie zamówień ZAM/ROK/1, 2, 3…; usunięto zbędną kolumnę stanu z eksportu zamówienia XLSX.

- Ukryto terminy z zerową ilością podczas poboru, podglądu i remanentu, zachowując dodawanie nowych wierszy oraz ilości bez terminu. Usunięto przełącznik, dodatkowy dialog i wymaganie backendu dotyczące potwierdzania poboru po terminie.

- Przebudowano interfejs zadań: magazyn jest wybierany w formularzu, kategorie mają hierarchię i wyszukiwarkę, a powtarzanie odsłania dodatkowe pola. Powiadomienia zgrupowano według magazynu/zadania, dodano oznaczanie grup jako przeczytanych i przeniesiono push do ustawień. Uporządkowano listę zadań, filtry, walidację oraz szczegóły z przejściem do istniejącego wizarda remanentu.

- 2026-10-31: Naprawiono fałszywy banner aktualizacji w nowej karcie/incognito przy rozbieżności Firestore i hostingu. Ogłoszenie w Firebase wywołuje sprawdzenie wydania faktycznie dostępnego na danym serwerze; bieżące wydanie usuwa banner.

- 2026-10-31: Domyślnie wyłączono maile o brakujących, zbliżających się i przekroczonych terminach ważności/przeglądów, również dla oczekujących powiadomień. Alerty w aplikacji i push pozostają aktywne; przyszłe włączenie wymaga jawnego ustawienia dateEmailsEnabled=true.

- 2026-10-31: Uproszczono podgląd terminów w magazynie: daty są zwykłym tekstem YYYY-MM zamiast selektorów; usunięto opis teoretycznych ilości i przycisk „Remanent / popraw daty w kreatorze”. Rozwinięty panel ma wcięcie, delikatne tło i lewą krawędź przypisującą go do produktu.

- 2026-10-31: Zmieniono automatyczny pobór FEFO: najpierw rozliczane są ilości z nieznanym terminem, a następnie najwcześniejsze terminy ważności/przeglądu. Ujednolicono kolejność w kreatorze i backendzie.

- 2026-10-31: Naprawiono instalację aktualizacji na EAS Hosting: adresy fontów w manifeście cache zachowują znak @ w nazwach pakietów zamiast kodowania %40, które zwracało 404 i przerywało instalację.

- 2026-10-31: Dodano sprawdzanie zgodności ogłoszonej wersji z hostingiem przed aktualizacją web, wykrywanie nieudanej instalacji workera i konkretne komunikaty błędów. Błędy cache z adresem pliku są przekazywane do konsoli strony; pobieranie ma ograniczony czas.

- 2026-10-31: Dodano ustawienia terminów ważności i przeglądów dla kategorii, dziedziczone przez wszystkie podkategorie i produkty. Dziedziczenie obejmuje kreator, magazyny, operacje i alerty; zachowano indywidualne ustawienia produktów.

- 2026-10-31: Usunięto ręczny przycisk sprawdzania konfliktów i uruchamiany przez niego spinner w kreatorze. Kontrola konfliktów przy zapisie remanentu pozostaje aktywna.

- 2026-10-31: Ograniczono selektor roku do bieżącego roku i kolejnych 15 lat; w podglądzie magazynu kompaktowe terminy rozwija ikona historii przy ilości zamiast osobnego nagłówka „Terminy i partie”.

- 2026-10-31: Uproszczono terminy w kreatorze do rozwijanych ikoną historii pojedynczych wierszy roku, miesiąca i ilości; dodano wiersz „Nieznane”, blokowanie ilości głównej i domyślne FEFO. Usunięto numery partii z kontraktów i UI; dodano opcjonalną migrację historycznego pola.
- 2026-10-31: Przeniesiono włączanie terminów do edycji produktu, a opiekunów do wyszukiwanego multiselectu w edycji magazynu. Wyłączone terminy nie są pokazywane ani uwzględniane w nowych zapisach i alertach.
- 2026-10-31: Naprawiono instalację cache workera na technicznych stronach Expo i dodano ograniczone czasowo włączanie push web z postępem oraz obsługą błędów. Dodano opcjonalny transport long-polling Firestore dla web przy zrywanych strumieniach QUIC.

- 2026-10-31: Dodano deploy backendu Firebase w pipeline'ach web i publikowanie wersji z package.json w Firestore po udanym wdrożeniu. Aplikacja web pokazuje banner aktualizacji; wspólny worker push pobiera kompletny cache nowego buildu i aktywuje go po potwierdzeniu użytkownika.

- 2026-10-31: Dodano `.gitattributes` i ujednolicono śledzone pliki tekstowe do LF, usuwając szum CRLF/LF w diffach; zachowano binarne PNG oraz wyjątki CRLF dla skryptów Windows.

- 2026-10-31: Poprawiono kolejność kontroli Functions w CI: kompilacja poprzedza lint, aby importy skompilowanych modułów w testach działały również w czystym checkout.

- 2026-10-31: Rozdzielono moduł zadań od partii; zlecony remanent otwiera istniejący kreator z właściwym magazynem i zakresem. Terminy i partie są dostępne przy pozycjach kreatora oraz w akordeonach stanu magazynu; dodano atomowy zapis wielu produktów i remanent bez zadania.

- 2026-10-31: Rozdzielono kontrole aplikacji i Functions; CI sprawdza lint, typy, kompilację i testy reguł oraz transakcji w lokalnym emulatorze projektu demo.

- 2026-10-31: Dodano moduł zadań ogólnych i remanentów, cykliczność od ostatniej realizacji, przypisywanie ratowników i kontrolę konfliktów stanów.
- 2026-10-31: Dodano partie magazynowe, daty ważności/przeglądów, FEFO, nierozliczony rozchód, wycofanie i kontrolowaną migrację magazynów.
- 2026-10-31: Dodano centrum powiadomień, opiekunów magazynów, alerty terminów i adaptery push FCM web/Android/iOS, wraz z testami domeny, transakcji i reguł.

- 2026-10-31: Dodano dokumentację sześciu współdzielonych komponentów UI oraz modali historii zamówień i limitów, wraz z kontraktami integracji i scenariuszami weryfikacji.

- 2026-10-31: Dostosowano instrukcje agentów i dokumenty Markdown do GOPR Inventory; dodano mapę architektury, danych, uprawnień, operacji, weryfikacji i znanych ryzyk.

## v1.0.75 - 2026-08-10

- Dodano stronicowanie list ewidencji i audytu.

## v1.0.74 - 2026-07-22

- Dodano odnośnik do innych projektów na ekranie kontaktu.

## v1.0.73 - 2026-06-30

- Usunięto aktualny stan magazynowy z zamówienia.

## v1.0.72 - 2026-06-30

- Dodano zamówienia magazynowe oraz poprawiono reguły Firestore i strefę czasową harmonogramu.

## v1.0.71 - 2026-05-19

- Poprawiono zapis harmonogramu tygodniowego i obsługę krótkich miesięcy w harmonogramie miesięcznym.

## v1.0.70 - 2026-05-19

- Dodano wybór dnia tygodnia i dnia miesiąca w harmonogramie raportów.

## v1.0.69 - 2026-05-19

- Dodano harmonogram raportów i obsługujące go funkcje Firebase.

## v1.0.68 - 2026-05-19

- Dodano pobieranie gotowych raportów.

## v1.0.67 - 2026-05-19

- Usunięto nadmiarowe odstępy menu i ujednolicono wysokość nagłówka.

## v1.0.66 - 2026-05-19

- Poprawiono wyrównanie nagłówków, obramowanie menu i sekcję użytkownika.

## v1.0.65 - 2026-05-19

- Dodano odświeżanie raportów po powrocie na ekran i przyciskiem.

## v1.0.64 - 2026-05-19

- Zmniejszono szerokość bocznego menu.

## v1.0.63 - 2026-05-19

- Dostosowano układ aplikacji do ekranów komputerów.

## v1.0.62 - 2026-05-19

- Dodano raport stanów poniżej limitu i ograniczenie końcowej daty raportu oraz zaktualizowano konfigurację Node.js w CI.

## v1.0.61 - 2026-05-06

- Zmniejszono filtry administracyjne i uzupełniono tłumaczenia.

## v1.0.60 - 2026-05-05

- Poprawiono układ filtrów administracyjnych i dodano wyszukiwanie operacji po numerze akcji dla administratorów.

## v1.0.59 - 2026-05-05

- Dodano filtrowanie użytkowników według roli w administracji.

## v1.0.58 - 2026-05-05

- Poprawiono widoczność ścieżki kategorii po rozwinięciu listy.

## v1.0.57 - 2026-05-05

- Dodano numer akcji w formacie liczba/liczba/liczba, wymagania numeru według kategorii i blokadę poboru.

## v1.0.56 - 2026-05-05

- Dodano logo RedMed na ekranie kontaktu i uporządkowano kontrolę widoczności elementów.

## v1.0.55 - 2026-05-05

- Udostępniono podgląd magazynów zalogowanym użytkownikom, zachowując ograniczenia historii i edycji limitów.

## v1.0.54 - 2026-05-05

- Poprawiono dołączanie ikon do eksportu aplikacji web.

## v1.0.53 - 2026-05-05

- Dodano ikony strony i ikonę skrótu na urządzeniach Apple.

## v1.0.52 - 2026-05-05

- Ujednolicono alfabetyczne sortowanie sprzętu w magazynie.

## v1.0.51 - 2026-05-05

- Poprawiono interpretację dat raportów z uwzględnieniem strefy czasowej.

## v1.0.50 - 2026-05-05

- Dodano edycję profilu, zmianę hasła i powiązanie logowania Google z kontem.

## v1.0.49 - 2026-05-05

- Ograniczono datę operacji do ostatnich 30 dni, bez możliwości wyboru daty przyszłej.

## v1.0.48 - 2026-05-05

- Uporządkowano przyciski i wyłączono automatyczne tłumaczenie strony przez przeglądarkę.

## v1.0.47 - 2026-05-05

- Uzupełniono nazwy i nagłówki raportów XLSX o zakres dat.

## v1.0.46 - 2026-05-05

- Poprawiono filtrowanie rzeczywistego zużycia po datach, wybór dat i prezentację autora raportu.

## v1.0.45 - 2026-05-04

- Dodano raport rzeczywistego zużycia z zakresem dat i wysyłkę raportów e-mailem.

## v1.0.44 - 2026-05-04

- Dodano moduł raportów dla osób uprawnionych i skróty w nawigacji.

## v1.0.43 - 2026-05-04

- Rozszerzono audyt o logowania, poprawiono podgląd operacji i magazynu oraz nawigację wstecz.

## v1.0.42 - 2026-05-04

- Dodano panel audytu dla administratora.

## v1.0.41 - 2026-05-04

- Dodano kontakt e-mail na ekranie gościa i kontekst użytkownika w raportach błędów.

## v1.0.40 - 2026-05-04

- Zwinięto selektory kategorii w edycji i dodano wskazówki dotyczące domyślnych limitów.

## v1.0.39 - 2026-05-04

- Dodano sortowanie użytkowników po e-mailu oraz podgląd dat utworzenia konta i ostatniego logowania.

## v1.0.38 - 2026-05-03

- Dostosowano widoczność ewidencji do ról i dodano historię konkretnego magazynu dla osób uprawnionych.

## v1.0.37 - 2026-05-03

- Poprawiono uprawnienia do zapisu ewidencji użycia.

## v1.0.36 - 2026-05-03

- Przeniesiono ustawianie minimalnej ilości do kategorii i usunięto nieużywany ekran sprzętu.

## v1.0.35 - 2026-05-03

- Poprawiono widoczność pola minimalnej ilości w formularzu.

## v1.0.34 - 2026-05-03

- Dostosowano reguły do minimalnych ilości oraz dodano przewijanie formularza edycji sprzętu.

## v1.0.33 - 2026-05-03

- Ustawiono nazwę aplikacji GOPR Inventory i dodano minimalne ilości sprzętu z możliwością nadpisania dla magazynu.

## v1.0.32 - 2026-05-03

- Ujednolicono wiersze list i rozmiary przycisków oraz zachowanie bocznej nawigacji na dużych ekranach.

## v1.0.31 - 2026-05-03

- Zwinięto formularz logowania e-mailem i hasłem pod osobnym przełącznikiem.

## v1.0.30 - 2026-05-03

- Ograniczono ilości poboru i przesunięcia do dostępnego stanu; poprawiono plik blokady zależności.

## v1.0.29 - 2026-05-03

- Uzupełniono obsługę bezpiecznych obszarów ekranu.

## v1.0.28 - 2026-05-03

- Uzupełniono zależność Worklets wymaganą przez Reanimated.

## v1.0.27 - 2026-05-03

- Uzupełniono zależność react-dom wymaganą do eksportu aplikacji web.

## v1.0.26 - 2026-05-03

- Poprawiono ścieżki grafik i zgodność zależności z React 19.1.

## v1.0.25 - 2026-05-03

- Poprawiono ekran główny, reguły dostępu i konfigurację wdrożeń oraz przygotowanie grafik aplikacji.

## v1.0.24 - 2026-05-03

- Dodano podgląd pozostałego stanu podczas wprowadzania poboru.

## v1.0.23 - 2026-05-03

- Poprawiono zapis poboru: odczyty transakcji Firestore są wykonywane przed zapisami.

## v1.0.22 - 2026-05-03

- Zgrupowano pozycje jednej operacji w karcie historii ewidencji.

## v1.0.21 - 2026-05-03

- Dostosowano siatkę ekranu głównego do szerokości ekranu: dwa lub cztery przyciski w wierszu.

## v1.0.20 - 2026-05-03

- Zintegrowano raportowanie błędów z Sentry.

## v1.0.19 - 2026-05-03

- Dodano moduł dokumentów.

## v1.0.18 - 2026-05-03

- Dostosowano przyciski ekranu głównego do roli użytkownika.

## v1.0.17 - 2026-05-03

- Rozszerzono kreator o dodawanie i przesunięcia, przełączanie widoku kategorii oraz blokadę ujemnych ilości.

## v1.0.16 - 2026-05-03

- Dodano wieloetapowy kreator poboru sprzętu.

## v1.0.15 - 2026-05-03

- Dodano ustawianie kolejności wyświetlania kategorii.

## v1.0.14 - 2026-05-03

- Dodano ustawianie kolejności wyświetlania magazynów.

## v1.0.13 - 2026-05-03

- Dodano zmianę kategorii nadrzędnej oraz kategorii przypisanej do sprzętu.

## v1.0.12 - 2026-05-03

- Poprawiono boczną nawigację i alfabetyczne sortowanie sprzętu.

## v1.0.11 - 2026-05-02

- Dodano ścieżkę nawigacji i rozwijane kategorie w magazynach.

## v1.0.10 - 2026-05-02

- Ujednolicono przeglądanie sprzętu oraz kategorii w hierarchicznym katalogu.

## v1.0.9 - 2026-05-02

- Dodano boczną nawigację i ekran kontaktowy.

## v1.0.8 - 2026-05-02

- Dodano przekierowanie z ekranu startowego zależnie od stanu logowania.

## v1.0.7 - 2026-05-02

- Dodano polską i angielską wersję interfejsu oraz zapamiętywanie wybranego języka.

## v1.0.6 - 2026-05-02

- Ujednolicono komunikaty na web i urządzeniach mobilnych oraz synchronizację nazwisk w publicznych profilach.

## v1.0.5 - 2026-05-02

- Usunięto wyścig podczas pobierania profilu po zmianie stanu uwierzytelnienia.

## v1.0.4 - 2026-05-02

- Poprawiono porównywanie uprawnień w regułach Firestore i zapisywanie czasu ostatniego logowania.

## v1.0.3 - 2026-05-02

- Dodano konfigurowanie nazwy bazy Firestore przez zmienną środowiskową.

## v1.0.2 - 2026-05-02

- Poprawiono wdrażanie web i reguł Firebase oraz logowanie Google na urządzeniach mobilnych.

## v1.0.1 - 2026-05-02

- Uruchomiono aplikację do ewidencji sprzętu i magazynów, z logowaniem oraz rolami użytkowników.
